import * as React from 'react';

import { formatText } from 'bernie-l10n';

import { classNames } from 'uitk-react-utils';

type ValidTag = 'div' | 'span' | 'a';

interface ShareMenuItemProps {
  renderAs?: ValidTag;
  onClick: () => void;
  openNewWindow: boolean;
}

const htmlTags = {
  div: 'div',
  span: 'span',
  a: 'a',
};

export const ShareMenuItem: React.FC<ShareMenuItemProps & React.HTMLProps<HTMLElement>> = ({
  onClick,
  openNewWindow,
  renderAs,
  children,
  className,
  ...props
}) => {
  const TagName = htmlTags[renderAs];
  const allProps = {
    ...props,
    className: classNames('uitk-list-item', className),
    role: 'menuItem',
    tabIndex: 0,
    onClick,
    onKeyPress: onClick,
  };

  return (
    <TagName {...allProps}>
      {children}
      {openNewWindow && (
        <span className="is-visually-hidden">{formatText('hotels.infosite.policies.missingIncorrectInfo.newWindowText')}</span>
      )}
    </TagName>
  );
};

ShareMenuItem.defaultProps = {
  renderAs: 'span',
};
